<template>
  <vacancy-videointerview-view
    :videointerview="videointerview"
    :name="name"
    :description="description"
    :questions="questions"
    :vacancy-id="vacancyId"
    :loading="loading"
    @set-questions="questions = $event"
    @set-name="name = $event"
    @set-description="description = $event"
    @add-question="add_question"
    @save-videointerview="save_videointerview"
    @update="update"
  />
</template>

<script>
import VacancyVideointerviewView from './VacancyVideointerviewView';
import Axios from 'axios';

const START_PRIORITY = 1000;
const PRIORITY_STEP = 100;

export default {
  name: 'VacancyVideointerviewDefault',

  components: {
    VacancyVideointerviewView
  },

  props: {
    vacancyId: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      loading: false,
      name: '',
      description: ''
    };
  },

  computed: {
    videointerview() {
      return this.$store.getters['vacancy/videointerview/one'];
    },

    questions: {
      get() {
        return this.videointerview.questions;
      },

      set(questions) {
        let i = START_PRIORITY;

        questions = questions.map(q => {
          const priority = i;
          i += PRIORITY_STEP;
          return Object.assign({}, q, { priority });
        });

        this.$store.commit('vacancy/videointerview/updateQuestions', questions);
      }
    }
  },

  beforeMount() {
    this.fetch();
  },

  async created() {
    await this.fetchVacancyStages();
  },

  methods: {
    async fetchVacancyStages() {
      this.isLoading = true;

      await Axios.get(`/v3/vacancy-stages/videointerview/${this.vacancyId}`)
        .then(response => {
          this.name = response.data.name;
          this.description = response.data.description;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async saveVacancyStages() {
      this.isLoading = true;

      await Axios.patch(`/v3/vacancy-stages/videointerview/${this.vacancyId}`, {
        name: this.name,
        description: this.description
      })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    fetch() {
      this.vacancyId &&
        this.$store.dispatch('vacancy/videointerview/fetch', {
          vacancyId: this.vacancyId
        });
    },

    add_question() {
      this.$store.commit('vacancy/videointerview/addQuestion');
    },

    async save_videointerview() {
      this.loading = true;

      await this.saveVacancyStages();

      await this.$store
        .dispatch('vacancy/videointerview/save', this.videointerview)
        .then(() => {
          this.$noty.success(this.$tr('vacancy.preferences.modals.saveSuccess.text')); // уточнить текст для сохранения настроек видеоинтервью
          // if (is_continue) {
          //   this.$router.push({ path: `/vacancies/${this.vacancyId}/competencies` });
          // }
        })
        .catch(() => {
          this.$noty.error(this.$tr('vacancy.preferences.modals.saveFailure.text')); // уточнить текст для ошибки сохранения настроек видеоинтервью
        })
        .finally(() => {
          this.loading = false;
        });
    },

    update(v) {
      this.$store.commit('vacancy/videointerview/update', v);
    }
  }
};
</script>
